import styled from "styled-components";
import FormInput from "./FormInput";

const FormTextArea = styled(FormInput)`
  min-height: 44px;
  height: auto;
  font-family: inherit;
  resize: none;
  padding: 12px 15px;
`;

export default FormTextArea;
